import { useCallback } from 'react';

import { useBroadcastScheduleProgram } from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import {
  PresenceCollectionKey,
  PresenceItem,
} from '@/features/broadcast-schedule-program/helpers/select-presence-collection';
import { TSegment } from '@/features/segments/types';

type SyncTarget = 'both' | 'global';

function usePresenceCollectionsSync() {
  const { setSegmentItems, setGlobalViewSegments } = useBroadcastScheduleProgram();

  const apply = useCallback(
    <K extends PresenceCollectionKey>(
      segmentId: string,
      key: K,
      updater: (items: PresenceItem<K>[]) => PresenceItem<K>[],
      target: SyncTarget = 'both'
    ) => {
      const transform = (prev: TSegment[]): TSegment[] =>
        prev.map(segment =>
          segment.id === segmentId
            ? { ...segment, [key]: updater((segment[key] ?? []) as PresenceItem<K>[]) }
            : segment
        );
      if (target === 'both') setSegmentItems(transform);
      setGlobalViewSegments(transform);
    },
    [setSegmentItems, setGlobalViewSegments]
  );

  return { apply };
}

export { usePresenceCollectionsSync };
export type { SyncTarget };
